// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"852":"6ba5207bbe0413b5","944":"7c9a99fb67032e33"}[chunkId] + ".js";
};